import { CheckSquareOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";
import ContentHeader from "../../../components/shared/ContentHeader";
import { StyledTasks } from "./styles";
import { useState, useCallback, useEffect } from "react";
import { useTenantTasks } from "../../../hooks/useTenantTasks";
import Board from "./Board";
import CreateTaskModal from "./Modal/CreateTaskModal";
import { useTenantUsers } from "../../../hooks/useTenantUsers";
import AddEditColumn from "./Modal/AddEditColumn";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../store/tasks/slice";
import ManageColumnsModal from "./Modal/ManageColumnsModal";

const Tasks = () => {
  const { columns, selectedTask, loading, setColumns } = useTenantTasks();
  const { users } = useTenantUsers();
  const [selectedColumn, setSelectedColumn] = useState(null);
  const dispatch = useDispatch();

  const setSelectedTask = useCallback(
    (value) =>
      dispatch(
        setKeyValue({
          value,
          key: "selectedTask",
        }),
      ),
    [],
  );

  return (
    <StyledTasks>
      <ContentHeader title="Task Management" icon={<CheckSquareOutlined />}>
        <ManageColumnsModal columns={columns} setColumns={setColumns} />
        <Button icon={<PlusOutlined />} onClick={() => setSelectedColumn({})}>
          Create Column
        </Button>
        <Button
          icon={<PlusOutlined />}
          type="primary"
          onClick={() => setSelectedTask({})}
        >
          Create Task
        </Button>
      </ContentHeader>
      {loading ? (
        <div className="loading flex-center">
          <Spin />
        </div>
      ) : (
        <Board
          columns={columns}
          setColumns={setColumns}
          setSelectedColumn={setSelectedColumn}
        />
      )}

      {selectedTask && (
        <CreateTaskModal
          onCancel={() => setSelectedTask(null)}
          columns={columns}
          users={users}
          selectedTask={selectedTask}
        />
      )}
      {selectedColumn && (
        <AddEditColumn
          onCancel={() => setSelectedColumn(null)}
          selectedColumn={selectedColumn}
        />
      )}
    </StyledTasks>
  );
};

export default Tasks;
